// extracted by mini-css-extract-plugin
module.exports = {"studentStatusContainer":"styles_studentStatusContainer__LO0it","active":"styles_active__12jkr","inactive":"styles_inactive__1jnwW"};